"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var FacilitiesModel = function FacilitiesModel(json, lang) {
  var data = []; // facilities

  if (json && json.establishment_facilities) {
    json.establishment_facilities.length > 0 && json.establishment_facilities.forEach(function (item, index) {
      var facility_name = '';
      var facility_group_name = '';
      var facility_icon_name = "";
      var facility = item.facility;

      if (facility) {
        if (facility.group) {
          facility_group_name = facility.group;
        }

        if (facility.icon) {
          facility_icon_name = facility.icon;
        }

        facility_name = facility.name;
        data.push({
          id: index,
          name: facility_name,
          value: item.value ? item.value : "",
          icon: facility_icon_name,
          category: facility_group_name
        });
      }
    });
  }

  if (json && json.enterprise_facilities) {
    json.enterprise_facilities.length > 0 && json.enterprise_facilities.forEach(function (item, index) {
      var facility_name = '';
      var facility_group_name = '';
      var facility_icon_name = "";
      var facility = item.facility;

      if (facility) {
        if (facility.group) {
          facility_group_name = facility.group;
        }

        if (facility.icon) {
          facility_icon_name = facility.icon;
        }

        facility_name = facility.name;
        data.push({
          id: index,
          name: facility_name,
          value: item.value ? item.value : "",
          icon: facility_icon_name,
          category: facility_group_name
        });
      }
    });
  }

  if (json && json.group_facilities) {
    json.group_facilities.length > 0 && json.group_facilities.forEach(function (item, index) {
      var facility_name = '';
      var facility_group_name = '';
      var facility_icon_name = "";
      var facility = item.facility;

      if (facility) {
        if (facility.group) {
          facility_group_name = facility.group;
        }

        if (facility.icon) {
          facility_icon_name = facility.icon;
        }

        facility_name = facility.name;
        data.push({
          id: index,
          name: facility_name,
          value: item.value ? item.value : "",
          icon: facility_icon_name,
          category: facility_group_name
        });
      }
    });
  }

  return data;
};

var _default = FacilitiesModel;
exports["default"] = _default;